module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DropDown', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "height": _vm.height,
      "isOpened": true,
      "alwaysOpen": _vm.alwaysOpen
    }
  }, [_c('Carousel', _vm._l((_vm.menu), function(type, index) {
    return _c('MenuCard', {
      key: index,
      staticClass: "separator",
      attrs: {
        "type": type
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1613896","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/remotemenu/RemoteEduMenu.vue
// module id = 5e62b2fe6d4045b9acbb
// module chunks = 89